import {useMantineTheme} from '@mantine/core'
import {Theme} from '@table-library/react-table-library/types/theme'
import {useMemo} from 'react'
import {mode} from '@appscience/utils'

export function useDataTableDefaultColorTheme(): Theme {
  const {colors, colorScheme, white, fn} = useMantineTheme()

  return useMemo(() => ({
    HeaderCell: `
      padding: 3px 0;
      border-bottom: none;
      &:not(.stiff) > div {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 10px;
        text-transform: uppercase;
        white-space: normal;
      }
      & .filter-icon path {
        fill: none;
      }
    `,
    HeaderRow: `
      color: ${mode(colors.gray[8], colors.gray[5])(colorScheme)};
      border-bottom: 1px solid ${mode(colors.gray[2], colors.gray[6])(colorScheme)};
      background-color: ${mode(colors.gray[0], fn.lighten(colors.dark[7], 0.05))(colorScheme)};
    `,
    BaseCell: `
      padding: 6px 0;
      border-right: none;
      &:not(.stiff)>div {
        white-space: normal;
      }
      &.rowActions {
        background-color: rgba(255, 255, 255, 0.9);
        box-shadow: -3px 0 3px -1px rgba(235, 235, 235);
        transition-duration: 150ms;
        opacity: 0;
      }
    `,
    Table: `
      border: 1px solid ${mode(colors.gray[2], colors.gray[6])(colorScheme)};
      border-radius: 16px;
    `,
    BaseRow: `
      &:hover .rowActions {
        opacity: 100;
      }
    `,
    Row: `
      color: ${mode(colors.gray[7], colors.gray[4])(colorScheme)};
      background-color: ${mode(white, colors.dark[6])(colorScheme)};
      font-weight: 500;
      font-size: 13px;
      border-bottom: 1px solid ${mode(colors.gray[2], colors.gray[6])(colorScheme)};
      &.interactive {
        background-color: ${mode(colors.violet[0], colors.green[0])(colorScheme)};
      }
      &.summary-row {
        position: sticky;
        bottom: 0;
        box-shadow: 0 -2px 3px -1px rgba(235, 235, 235);
        padding-top: 3px;
        background-color: ${mode(colors.blue[0], white)(colorScheme)};
      }
      
      &:hover {
        font-weight: 500;
        color: ${mode(colors.gray[8], white)(colorScheme)};
        transition-duration: 150ms;
        background-color: ${mode(colors.blue[0], white)(colorScheme)};
      }
      &.row-select-selected, &.row-select-single-selected {
        font-weight: 500;
        transition-duration: 150ms;
        background-color: ${mode(colors.blue[1], fn.rgba(colors.blue[5], 0.17))(colorScheme)};
        color: ${mode(colors.gray[8], white)(colorScheme)};
      }
    `,
  }), [colorScheme, colors.blue, colors.dark, colors.gray, colors.green, colors.violet, fn, white])
}